/**
 * Small "Interventie" pill: marks a task or fase carrying the Odoo `Interventie`
 * tag (itself or its fase), so a repair is told apart from a real werf at a
 * glance — on the installer / interventie task lists and the dashboard fase bar.
 */
export function InterventieBadge({ className = '' }: { className?: string }) {
  return (
    <span
      title="Interventie"
      className={`inline-flex shrink-0 items-center rounded-full bg-td-purple/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-td-purple ${className}`}
    >
      Interventie
    </span>
  );
}
